/**
 * スマートフォンメニュー 開閉
 */
$(document).on('click','.js-sp-btn-menu-toggle',function(){
	var $btn  = $(this);
	var $menu = $('.g-header-sp-overlay');
	if(
		$btn.length === 0  ||
		$menu.length === 0
	) return false;
	$menu.fadeToggle();
});

/**
 * 子メニュー
 */
$(function(){
	const $headerMenuToggle = $('.js-header-child-toggle');
	for(let i = 0;i < $headerMenuToggle.length;++i){
		let $item = $headerMenuToggle.eq(i);
		let $btn  = $item.children('a');
		let $menu = $item.children('ul');
		if(
			$btn.length === 0 ||
			$menu.length === 0
		) continue;
		$btn.on('click',function(e){
			e.preventDefault();
			if($menu.css('display') === 'none'){
				$menu.css('display','flex').hide();
				$headerMenuToggle.not($menu).removeClass('_active').children('ul').slideUp();
			}
			$menu.slideToggle();
			$item.toggleClass('_active');
			return false;
		});
	}
});


/**
 * 追従
 */
!function(){
	var $body   = $('body');
	var $header = $('#globalHeader');
	if($header.length == 0) return false; 
	function stickyHeader(){
		var h = $header.innerHeight();
		$body.css({'padding-top':h+'px'});
		$body.addClass('active_sticky_header');
	}
	$(window).on('load resize',function(){setTimeout(stickyHeader,500)});
}();